<template>
  <div :class="classes">
    <label v-if="label && !infieldTopAligned">{{ label }}</label>
    <slot></slot>
    <label v-if="label && infieldTopAligned">{{ label }}</label>
    <div
      v-if="disclaimer"
      class="form-field__disclaimer"
      v-html="formattedDisclaimer"
    />
  </div>
</template>

<script>
export default {
  props: {
    invalid: { type: Boolean, default: false },
    inline: { type: Boolean, default: false },
    reverse: { type: Boolean, default: false },
    infieldTopAligned: { type: Boolean, default: false },
    label: { type: String, default: null },
    disclaimer: { type: String, default: null }
  },

  computed: {
    classes() {
      return [
        'ewr-form-field',
        'form-field',
        'form__field',
        {
          'form-field--error': this.invalid,
          'form-field--inline': this.inline,
          'form-field--reverse': this.reverse,
          'form-field--infield-top-aligned': this.infieldTopAligned,
          'form-field--has-disclaimer': this.disclaimer,
          'form__field--error': this.invalid,
          'form__field--inline': this.inline,
          'form__field--reverse': this.reverse,
          'form__field--infield-top-aligned': this.infieldTopAligned,
          'ewr-form-field--infield-top-aligned': this.infieldTopAligned
        }
      ]
    },

    formattedDisclaimer() {
      return this.disclaimer
        ? this.$options.filters.markdown(this.disclaimer)
        : null
    }
  }
}
</script>

<style lang="scss">
.form-field,
.form__field {
  @include border-box;
  // @include clearfix;
  margin-top: $blh;
  margin-bottom: $blh;
  padding: 0px;
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;

  &__disclaimer {
    p:first-child {
      margin: 0 !important;
    }
  }

  &--inline {
    flex-direction: row;
    align-items: center;
  }

  &--reverse {
    label {
      order: 1;
    }
  }

  input {
    flex-shrink: 0;
  }

  @import './scss/form-field/input';
  // @import "./file";
  @import './scss/form-field/textarea';
  @import './scss/form-field/contenteditable';
  @import './scss/form-field/label';
  @import './scss/form-field/infield-top-aligned';
  @import './scss/form-field/error';

  div[contenteditable][disabled] {
    pointer-events: none;
    background: $gray50;
  }

  label {
    white-space: nowrap;
  }

  .hint {
    @include font-size(-2);
    color: $gray600;
    margin-left: blh(0.5);
  }
}
</style>
